import { dayRange, nyNow } from "@/lib/hours";

export function HoursTable({ hours, testid }) {
  const today = nyNow().day;
  return (
    <table className="w-full text-sm" data-testid={testid}>
      <tbody>
        {hours.map((h, i) => (
          <tr key={h.day} className={`border-b border-white/5 ${i === today ? "text-[var(--gold)]" : "text-white/75"}`}>
            <td className="py-2 font-display text-base font-bold uppercase tracking-wide">{h.day}{i === today && <span className="ml-2 font-mono-ui text-[10px]">Today</span>}</td>
            <td className="py-2 text-right font-mono-ui text-xs">{dayRange(h)}</td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}
